import React, { Component } from "react";

interface Props {
    logo?: string;
    color?: string;
    homeLink?: string;
    headertransparent?: string;
    colorblack?: string;
    logoname?: string;
}

interface State {
    isSticky: boolean;
}

class Header extends Component<Props, State>{
    private scrollHandler: (() => void) | null = null;

    constructor(props: Props) {
        super(props);
        this.state = { isSticky: false };
    }

    componentDidMount() {
        this.scrollHandler = () => {
            var value = window.scrollY;
            var header = document.querySelector('.header--fixed');
            if (header) {
                if (value > 100) {
                    header.classList.add('sticky');
                    this.setState({ isSticky: true });
                } else {
                    header.classList.remove('sticky');
                    this.setState({ isSticky: false });
                }
            }
        };
        window.addEventListener('scroll', this.scrollHandler);
    }

    componentWillUnmount() {
        if (this.scrollHandler) {
            window.removeEventListener('scroll', this.scrollHandler);
        }
    }

    render(): React.ReactNode{
        const { color='default-color' } = this.props;
        const { isSticky } = this.state;

        return(
            <header className={`header-area header--fixed ${color}`}>
                <div className="header-wrapper">
                    <div className="header-left d-flex align-items-center">
                        <div className="logo">
                            <a href="/">
                               <h3 style={{marginTop: '15px',fontSize: '30px', color: isSticky ? '#1d1d24' : '#ffffff', transition: 'color 0.3s'}}>Portfolio</h3>
                            </a>
                        </div>
                    </div>
                </div>
            </header>
        )
    }
}
export default Header;